(function() {
  if($('.custom_faq__item').length) {
    // The buttons ship an aria-expanded attribute but nothing kept it in sync, so a
    // screen reader was told every panel was closed (or open) regardless of state.
    function syncAria($scope) {
      $scope.find('.custom_faq__item').each(function() {
        $(this).find('.accordion-button').attr('aria-expanded', $(this).hasClass('active') ? 'true' : 'false');
      });
    }

    $('body').on('click', '.custom_faq__question', function() {
      var $group = $(this).parent().parent();
      if($(this).parent().hasClass('active')) {
        $(this).next('.custom_faq__answer').slideUp(150);
        $(this).parent().removeClass('active');
      } else {
        $group.find('.custom_faq__answer').slideUp(150);
        $group.find('.custom_faq__item').removeClass('active');
        $(this).parent().toggleClass('active');
        $(this).next('.custom_faq__answer').slideToggle(150);
      }
      syncAria($group);
    });

    syncAria($(document));
  }

  $(document).on('shopify:block:select', '#shopify-section-page-custom_faq-template', function(event) {
    $(event.target).find('.custom_faq__answer').slideDown(150);
  });

  $(document).on('shopify:block:deselect', '#shopify-section-page-custom_faq-template', function(event) {
    $(event.target).find('.custom_faq__answer').slideUp(150);
  });
}());